require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/fn/object/assign.js
// module id = ../../../../core-js/library/fn/object/assign.js
// module chunks = 7